import config from "config/config";

export async function validateAgentInODS(
  AgentType,
  AgentId,
  FirstName,
  LastName,
  IdentityNumber,
  PostalCode,
  MobileNumber,
  Email,
  userId
) {
  let queryString = "";

  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  if (AgentType === "agent") {
    queryString =
      "AgentId=" +
      encodeURIComponent(AgentId) +
      "&FirstName=" +
      encodeURIComponent(FirstName) +
      "&LastName=" +
      encodeURIComponent(LastName) +
      "&IdentityNumber=" +
      IdentityNumber +
      "&MobileNumber=" +
      MobileNumber;
  } else {
    queryString =
      "FirstName=" +
      encodeURIComponent(FirstName) +
      "&LastName=" +
      encodeURIComponent(LastName) +
      "&PostalCode=" +
      PostalCode +
      "&MobileNumber=" +
      MobileNumber +
      "&EmailId=" +
      encodeURIComponent(Email);
    if (userId) {
      queryString = queryString + "&userId=" + userId;
    }
  }

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/validateagent?" + queryString,
    options
  );

  if (!response.ok) {
    const data = await response.json();
    if (
      response.status === 401 &&
      data?.errors[0]?.description === "Token Invalid or Expired"
    ) {
      throw response;
    } else {
      if (
        response.status === 404 ||
        response.status === 403 ||
        response.status === 401
      ) {
        return data;
      } else {
        throw response;
      }
    }
  } else {
    const data = await response.json();
    return data;
  }
}
